import { render, staticRenderFns } from "./FavoriteLocation.vue?vue&type=template&id=a5601792"
import script from "./FavoriteLocation.vue?vue&type=script&lang=js"
export * from "./FavoriteLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports